<!-- Counters -->
<section class="min-h-40">
    <div class="pt-12">
        <div class="pb-12  sm:pb-16">
            <div class="w-full">
                <div class="px-4 mx-auto h-70 sm:px-6 lg:px-8">
                    <div class="max-w-4xl   mx-auto">
                        <div class="flex flex-col md:flex-row justify-between items-center rounded-lg grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4">
                            <div class="flex justify-center items-center mt-10">
                                <mat-icon class="icon-size-10 sm:icon-size-12 mr-4 p-2 bg-accent-200 rounded-full text-primary-500"
                                    [svgIcon]="'mat_outline:people_outline'"></mat-icon>
                                <div class="flex flex-col">
                                    <div class="text-xl sm:text-4xl font-bold leading-none">
                                        150K+
                                    </div>
                                    <div class="text-md sm:text-lg leading-6 text-gray-500">
                                        Our Explorers
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-center items-center mt-10">
                                <mat-icon class="icon-size-10 sm:icon-size-12 mr-4 p-2 bg-accent-200 rounded-full text-primary-500"
                                    [svgIcon]="
                                        'heroicons_outline:globe-europe-africa'
                                    "></mat-icon>
                                <div class="flex flex-col">
                                    <div class="text-xl sm:text-4xl font-bold leading-none">
                                        10K+
                                    </div>
                                    <div class="text-md sm:text-lg leading-6 text-gray-500">
                                        Destinations
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-center items-center mt-10">
                                <mat-icon class="icon-size-10 sm:icon-size-12 mr-4 p-2 bg-accent-200 rounded-full text-primary-500"
                                    [svgIcon]="
                                        'heroicons_outline:arrow-path-rounded-square'
                                    "></mat-icon>
                                <div class="flex flex-col">
                                    <div class="text-xl sm:text-4xl font-bold leading-none">
                                        50K+
                                    </div>
                                    <div class="text-md sm:text-lg leading-6 text-gray-500">
                                        More Trips
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-center items-center mt-10">
                                <mat-icon class="icon-size-10 sm:icon-size-12 mr-4 p-2 bg-accent-200 rounded-full text-primary-500"
                                    [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                                <div class="flex flex-col">
                                    <div class="text-xl sm:text-4xl font-bold leading-none">
                                        100K+
                                    </div>
                                    <div class="text-md sm:text-lg leading-6 text-gray-500">
                                        Luxury Hotels
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>